import { APP_VERSION } from "../cloud-config"
import { triggerDocAuditReportExport, triggerDisciplineFormGeneration, exportProfileDataTemplate } from "../providers"
import { SessionService } from "./sessionService"
import { AssociationId, AuthCredentials, CohortName, DocAuditReportResponse, Email } from "../types"

export class ExportService {
  async exportRemoteData(
    selectedAssociation: any,
    selectedProfiles: string[],
    selectedExportTemplate: any,
    selectedExportFormat: string,
    excludeHeaderRow: boolean,
    emails: any,
    authCredentials: AuthCredentials,
  ): Promise<void> {
    const payload = {
      selectedEmployer: selectedAssociation,
      selectedProfiles,
      selectedExportTemplate,
      selectedExportFormat,
      excludeHeaderRow,
      emails,
      webVersion: APP_VERSION,
    }
    const { username, password } = authCredentials
    const token = await SessionService.prepareAuthTokens(username, password)
    exportProfileDataTemplate(payload, token)
  }

  async exportDocAuditReport(
    selectedAssociation: AssociationId,
    emails: Email[],
    cohorts: CohortName[],
    authCredentials: AuthCredentials,
  ): Promise<DocAuditReportResponse> {
    const params = {
      association: selectedAssociation,
      cohorts,
      emails,
      ignoreJobType: true,
      flagUnpersisted: true,
    }
    const { username, password } = authCredentials
    const token = await SessionService.prepareAuthTokens(username, password)
    return await triggerDocAuditReportExport(params, token)
  }

  async generateBulkDisciplineForms(
    selectedAssociation: string,
    selectedDate: Date,
    emails: string[],
    authCredentials: AuthCredentials,
  ): Promise<void> {
    try {
      const { username, password } = authCredentials
      const token = await SessionService.prepareAuthTokens(username, password)
      await triggerDisciplineFormGeneration(selectedAssociation, selectedDate, emails, token)
    } catch (error) {
      throw error
    }
  }
}
